export default {
  meta: {
    title: '采购单详情'
  }
};

